export function isSelected({ acctId, selectedList }) {
	// after deletion, selected list is unset so check for it
	if (selectedList && selectedList.distList) {
		return selectedList.distList.some(x => x === acctId);
	}
}

export function isExpanded({ keyVal, expanded }) {
	if (expanded && Array.isArray(expanded)) {
		return expanded.some(x => x === keyVal);
	}
}

export const convertBody = (listValue, splitType) => {
	const dataSplit = listValue.map(data => {
		return data.split(splitType)[0] //get 1st value => 1st column

	})
	const dataRemovedEmpty = dataSplit.filter(data => data !== '')
	return dataRemovedEmpty
}

export const splitAndRemoveEmptyData = (data) => {
	const lines = data.split(/\r\n|\r|\n/);
	const uniqueData = [...new Set(lines)]//get unique item
	const removeEmptyData = uniqueData.filter((data) => data !== '') //remove item ''
	return removeEmptyData
}
